<template lang="html">
  <div class="flex flex-wrap gap-2">
    <button
      v-for="(id, index) in props.imageIds"
      :key="id"
      type="button"
      class="size-20 cursor-zoom-in overflow-hidden border border-default"
      :aria-label="`Открыть фото ${index + 1} из ${props.imageIds.length}`"
      @click="open(index)"
    >
      <UiPicture
        :src="id"
        variant="imageFull"
        :alt="`Фото к отзыву ${index + 1}`"
        sizes="80px"
        loading="lazy"
        class="block size-full"
      />
    </button>

    <!-- lightgallery грузится лениво, только при первом открытии фото -->
    <ClientOnly>
      <LightgalleryContainer v-if="needGallery" key="gallery" :onInit="handleInitGallery">
        <a v-for="slide in slides" :key="slide.id" :data-src="slide.src" />
      </LightgalleryContainer>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import type { LightGallery } from 'lightgallery/lightgallery'
import 'lightgallery/css/lightgallery.css'

import UiPicture from '~/app/components/Image/UiPicture.vue'

const props = defineProps<{ imageIds: string[] }>()

const LightgalleryContainer = defineAsyncComponent(() => import('lightgallery/vue'))

const { support } = useResources()

const needGallery = ref(false)
const gallery = shallowRef<LightGallery>()
/** Какое фото открыть, когда галерея догрузится и проинициализируется */
let pendingIndex = 0

const slides = computed(() =>
  props.imageIds.map(id => ({ id, src: support.getResourceUrl(id) })),
)

function handleInitGallery(detail: { instance: LightGallery }) {
  gallery.value = detail.instance
  gallery.value.openGallery(pendingIndex)
}

function open(index: number) {
  pendingIndex = index
  if (gallery.value) gallery.value.openGallery(index)
  else needGallery.value = true
}
</script>
